import React from 'react';

export function RatingStartFull() {
	return (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_468_991)">
				<path
					d="M17.1788 1.66186C17.0906 1.48379 16.9543 1.33392 16.7855 1.22914C16.6166 1.12437 16.4218 1.06885 16.2231 1.06885C16.0244 1.06885 15.8296 1.12437 15.6607 1.22914C15.4918 1.33392 15.3556 1.48379 15.2674 1.66186L10.9004 10.5088L1.13615 11.9275C0.939141 11.9561 0.754066 12.0392 0.601867 12.1676C0.449667 12.2959 0.336418 12.4643 0.27493 12.6536C0.213443 12.8429 0.206171 13.0457 0.253938 13.239C0.301705 13.4322 0.402604 13.6083 0.545221 13.7472L7.61082 20.6336L5.94255 30.3595C5.90909 30.5555 5.93108 30.7569 6.00605 30.9411C6.08102 31.1253 6.20598 31.2849 6.36683 31.4018C6.52768 31.5187 6.71802 31.5883 6.91634 31.6028C7.11467 31.6173 7.3131 31.576 7.48922 31.4837L16.2231 26.8907L24.957 31.4837C25.1331 31.576 25.3315 31.6173 25.5298 31.6028C25.7282 31.5883 25.9185 31.5187 26.0793 31.4018C26.2402 31.2849 26.3652 31.1253 26.4401 30.9411C26.5151 30.7569 26.5371 30.5555 26.5036 30.3595L24.8354 20.6315L31.901 13.7472C32.0436 13.6083 32.1445 13.4322 32.1922 13.239C32.24 13.0457 32.2327 12.8429 32.1712 12.6536C32.1098 12.4643 31.9965 12.2959 31.8443 12.1676C31.6921 12.0392 31.507 11.9561 31.31 11.9275L21.5458 10.5088L17.1788 1.66186Z"
					fill="#FFA310"
				/>
			</g>
			<defs>
				<clipPath id="clip0_468_991">
					<rect
						width="32"
						height="32"
						fill="white"
						transform="translate(0.222778)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
